// @flow
import * as React from 'react';
import { useClient } from '../../hooks/client-context';
import { Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { RichEditorField } from '../../../../features';
import { useDebouncedEffect } from '@coverright/utils';
import { useSaveManagerNoteMutation } from '../../../../shared';

export const ManagerNote = () => {
  const client = useClient();
  const [note, setNote] = useState('');
  const [save] = useSaveManagerNoteMutation()

  useEffect(() => {
    setNote(client.managerNote || '')
  }, [client.managerNote])

  useDebouncedEffect(() => {
    client.id && note !== client.managerNote && save({
      variables: {clientId: client.id, managerNote: note}
    });
  }, 1000, [note, client.id])

  return (
    <Stack gap={2} flex={1}>
      <Typography variant={'subtitle1'}>Manager notes</Typography>
      <RichEditorField value={note} onChange={setNote} />
    </Stack>

  );
};
